import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    "width": "100%",
    "text-align": "center"
  }
};
const _hoisted_2 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_5 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback");
  const _component_b_form_group = _resolveComponent("b-form-group");
  const _component_b_row = _resolveComponent("b-row");
  const _component_Checkbox = _resolveComponent("Checkbox");
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_card_text = _resolveComponent("b-card-text");
  const _component_b_card = _resolveComponent("b-card");
  const _component_b_container = _resolveComponent("b-container");
  return _openBlock(), _createBlock(_component_b_container, {
    role: "region",
    "aria-label": "forgot password"
  }, {
    default: _withCtx(() => [_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_spinner, {
      variant: "success",
      style: {
        "width": "3rem",
        "height": "3rem"
      }
    })])) : _createCommentVNode("", true), _createVNode(_component_b_row, null, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        cols: "12",
        md: "6",
        class: "mt-4"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_card, {
          header: "Reset Password"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
            default: _withCtx(() => [_createVNode(_component_b_row, {
              class: "text-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_b_col, {
                cols: "12"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Enter your username below to reset your password ", -1)]))], undefined, true),
                _: 1
              }), _createVNode(_component_b_col, {
                cols: "12",
                class: "mt-4"
              }, {
                default: _withCtx(() => [_createVNode(_component_b_row, {
                  class: "text-start"
                }, {
                  default: _withCtx(() => [_createVNode(_component_b_col, {
                    cols: "4",
                    class: "pt-1"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createElementVNode("b", null, "Username:", -1)]))], undefined, true),
                    _: 1
                  }), _createVNode(_component_b_col, {
                    cols: "8"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_b_form_group, null, {
                      default: _withCtx(() => [_createVNode(_component_b_form_input, {
                        modelValue: _ctx.username,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.username = $event),
                        type: "text",
                        onBlur: _cache[1] || (_cache[1] = $event => _ctx.$v.username.$touch()),
                        state: _ctx.$v.username.$error ? false : null,
                        autocomplete: "username"
                      }, null, 8, ["modelValue", "state"]), _createVNode(_component_b_form_invalid_feedback, null, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Username is required ", -1)]))], undefined, true),
                        _: 1
                      })], undefined, true),
                      _: 1
                    })], undefined, true),
                    _: 1
                  })], undefined, true),
                  _: 1
                })], undefined, true),
                _: 1
              }), _createVNode(_component_b_col, {
                cols: "12",
                class: "mt-3"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_vue_recaptcha, {
                  sitekey: "6Le-L6wZAAAAANrSopXo5MQU4rPseWwOZDndebHd",
                  onVerify: $options.handleResetSuccess,
                  onError: $options.handleResetError,
                  style: {
                    "text-align": "center"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_Checkbox, {
                    style: {
                      "display": "inline-block",
                      "text-align": "center"
                    }
                  })], undefined, true),
                  _: 1
                }, 8, ["onVerify", "onError"])])], undefined, true),
                _: 1
              }), _createVNode(_component_b_col, {
                cols: "12"
              }, {
                default: _withCtx(() => [_createVNode(_component_b_button, {
                  variant: "danger",
                  disabled: _ctx.$v.username.$invalid || _ctx.loading || _ctx.reset || !_ctx.resetCaptchaResponse,
                  onClick: _cache[2] || (_cache[2] = $event => $options.resetPassword())
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("Reset Password", -1)]))], undefined, true),
                  _: 1
                }, 8, ["disabled"])], undefined, true),
                _: 1
              }), _ctx.resetMessageHTML !== '' ? (_openBlock(), _createBlock(_component_b_col, {
                key: 0,
                cols: "12",
                class: "text-success"
              }, {
                default: _withCtx(() => [_createElementVNode("b", null, [_createElementVNode("span", {
                  innerHTML: _ctx.resetMessageHTML
                }, null, 8, _hoisted_3)])], undefined, true),
                _: 1
              })) : _createCommentVNode("", true)], undefined, true),
              _: 1
            })], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      }), _createVNode(_component_b_col, {
        cols: "12",
        md: "6",
        class: "mt-4"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_card, {
          header: "Recover Username"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
            default: _withCtx(() => [_createVNode(_component_b_row, {
              class: "text-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_b_col, {
                cols: "12"
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Enter your email below to recover your username ", -1)]))], undefined, true),
                _: 1
              }), _createVNode(_component_b_col, {
                cols: "12",
                class: "mt-4"
              }, {
                default: _withCtx(() => [_createVNode(_component_b_row, {
                  class: "text-start"
                }, {
                  default: _withCtx(() => [_createVNode(_component_b_col, {
                    cols: "4",
                    class: "pt-1"
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("b", null, "Email:", -1)]))], undefined, true),
                    _: 1
                  }), _createVNode(_component_b_col, {
                    cols: "8"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_b_form_group, null, {
                      default: _withCtx(() => [_createVNode(_component_b_form_input, {
                        modelValue: _ctx.email,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.email = $event),
                        type: "text",
                        onBlur: _cache[4] || (_cache[4] = $event => _ctx.$v.email.$touch()),
                        state: _ctx.$v.email.$error ? false : null,
                        autocomplete: "email"
                      }, null, 8, ["modelValue", "state"]), _ctx.$v.email.required.$invalid ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                        key: 0
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Email is required ", -1)]))], undefined, true),
                        _: 1
                      })) : _createCommentVNode("", true), _ctx.$v.email.email.$invalid ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                        key: 1
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" Please enter a valid email ", -1)]))], undefined, true),
                        _: 1
                      })) : _createCommentVNode("", true)], undefined, true),
                      _: 1
                    })], undefined, true),
                    _: 1
                  })], undefined, true),
                  _: 1
                })], undefined, true),
                _: 1
              }), _createVNode(_component_b_col, {
                cols: "12",
                class: "mt-3"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_vue_recaptcha, {
                  sitekey: "6Le-L6wZAAAAANrSopXo5MQU4rPseWwOZDndebHd",
                  onVerify: $options.handleRecoverSuccess,
                  onError: $options.handleRecoverError,
                  style: {
                    "text-align": "center"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_Checkbox, {
                    style: {
                      "display": "inline-block",
                      "text-align": "center"
                    }
                  })], undefined, true),
                  _: 1
                }, 8, ["onVerify", "onError"])])], undefined, true),
                _: 1
              }), _createVNode(_component_b_col, {
                cols: "12"
              }, {
                default: _withCtx(() => [_createVNode(_component_b_button, {
                  variant: "danger",
                  disabled: _ctx.$v.email.$invalid || _ctx.loading || _ctx.recovered || !_ctx.recoverCaptchaResponse,
                  onClick: _cache[5] || (_cache[5] = $event => $options.recoverUsername())
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("Recover Username", -1)]))], undefined, true),
                  _: 1
                }, 8, ["disabled"])], undefined, true),
                _: 1
              }), _ctx.recoverMessageHTML !== '' ? (_openBlock(), _createBlock(_component_b_col, {
                key: 0,
                cols: "12",
                class: "text-success"
              }, {
                default: _withCtx(() => [_createElementVNode("b", null, [_createElementVNode("span", {
                  innerHTML: _ctx.recoverMessageHTML
                }, null, 8, _hoisted_5)])], undefined, true),
                _: 1
              })) : _createCommentVNode("", true)], undefined, true),
              _: 1
            })], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  });
}